import axios from 'axios'
import {message} from "ant-design-vue";

const request = axios.create({
    timeout: 50000
})
export const domain=
    //'http://localhost:8080/api'
'/api'
request.interceptors.request.use(config => {
    config.baseURL = domain
    const token = localStorage.getItem("token")
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

// 统一解包后端 Result<T> 响应体
let isRedirecting = false;
request.interceptors.response.use(
    res => {
        const body = res.data
        // 如果是统一响应体格式，进行解包
        if (body && typeof body.code === 'number') {
            if (body.code === 200) {
                res.data = body.body.data
            } else {
                message.error(body.message || "请求失败")
                return Promise.reject(new Error(body.message || "请求失败"))
            }
        }
        return res
    },
    error => {
        // HTTP 错误也可能携带统一响应体
        const body = error.response?.data
        if (body && body.message) {
            message.error(body.message)
        }
        if (error.response?.status === 401) {
            if (!isRedirecting) {
                isRedirecting = true;
                message.error("登录已过期，请重新登录")
                localStorage.removeItem("token")
                window.location.href = "/login"
            }
        }
        return Promise.reject(error)
    }
)
export default request
